import { useGetTableColumnSettingsQuery } from "store/api/auth";
import {
  useChangePasswordMutation,
  useDeleteProfileMutation,
  useEditProfileMutation,
  useFileUploadBase64Mutation,
  useFileUploadMutation,
  useGlobalConfigQuery,
  useProfileQuery,
} from "store/api/profile";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useProfileHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const { data: userData, refetch: refetchUserData } = useProfileQuery({
    refetchOnMountOrArgChange: true,
  });
  // forcing the query to always fetch when this component is mounted
  // { refetchOnMountOrArgChange: true }
  const [editProfile, { isLoading: profileLoading }] = useEditProfileMutation({
    fixedCacheKey: fixedCacheKeys.EDIT_PROFILE,
  });

  const [fileUpload, { isLoading: isImageLoader }] = useFileUploadMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD,
  });

  const [fileUploadBase64, { isLoading: isImageBase64Loader }] =
    useFileUploadBase64Mutation({
      fixedCacheKey: fixedCacheKeys.FILE_UPLOAD,
    });

  const { data: globalConfigData } = useGlobalConfigQuery({
    refetchOnMountOrArgChange: true,
  });

  const [changePassword, { isLoading: passwordLoading }] =
    useChangePasswordMutation({
      fixedCacheKey: fixedCacheKeys.CHANGE_PASSWORD,
    });

  const [deleteProfile, { isLoading: deleteProfileLoading }] =
    useDeleteProfileMutation({
      fixedCacheKey: fixedCacheKeys.DELETE_PROFILE,
    });

  const { data: columnTableSettingData } = useGetTableColumnSettingsQuery();

  return {
    isImageLoader,
    changePassword,
    passwordLoading,
    profileLoading,
    userData,
    editProfile,
    fileUpload,
    fileUploadBase64,
    isImageBase64Loader,
    refetchUserData,
    globalConfigData,
    deleteProfile,
    deleteProfileLoading,
    columnTableSettingData,
  };
};
